export function GoogleLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
        fill="#EA4335"
      />
    </svg>
  );
}

export function FacebookLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#1877F2" />
      <path
        d="M16.035 12.39h-2.583v9.61h-3.993v-9.61H7.555V8.985h1.904V6.75c0-2.665 1.109-4.25 4.288-4.25 1.166 0 2.378.208 2.378.208v2.61h-1.34c-1.318 0-1.726.818-1.726 1.656v1.996h2.959l-.983 3.42z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export function InstagramLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient
          id="ig-grad"
          cx="30%"
          cy="107%"
          r="150%"
        >
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#ig-grad)" />
      <path
        d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm5.25-8.55a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0z"
        fill="#FFFFFF"
      />
      <rect
        x="3.2"
        y="3.2"
        width="17.6"
        height="17.6"
        rx="4.8"
        stroke="#FFFFFF"
        strokeWidth="1.8"
        fill="none"
      />
    </svg>
  );
}

export function WhatsAppLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <img
      src="/icons/whatsapp-icon.svg"
      alt="WhatsApp"
      className={className}
    />
  );
}

export function MetaLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.93 13.91c-.48 1.4-1.54 2.59-2.98 3.16-1.54.61-3.26.31-4.66-.66-.88-.61-1.61-1.42-2.3-2.28-.69.86-1.42 1.67-2.3 2.28-1.4.97-3.12 1.27-4.66.66-1.44-.57-2.5-1.76-2.98-3.16-.54-1.56-.25-3.37.75-4.68 1.02-1.34 2.65-2.09 4.31-1.99 1.44.09 2.76.85 3.65 1.95.42.52.8 1.08 1.23 1.65.43-.57.81-1.13 1.23-1.65.89-1.1 2.21-1.86 3.65-1.95 1.66-.1 3.29.65 4.31 1.99 1 1.31 1.29 3.12.75 4.68Zm-4.9-5.32c-.99.06-1.89.58-2.5 1.34-.33.41-.63.85-.97 1.31-.29.39-.58.78-.88 1.18.73.91 1.42 1.7 2.24 2.27.94.65 2.12.86 3.18.44 1-.39 1.73-1.22 2.06-2.19.37-1.07.17-2.31-.51-3.21-.69-.91-1.79-1.42-2.91-1.35C16.89 8.42 17.06 8.58 17.03 8.59Zm-10.06 0c-1.12-.07-2.22.44-2.91 1.35-.68.9-.88 2.14-.51 3.21.33.97 1.06 1.8 2.06 2.19 1.06.42 2.24.21 3.18-.44.82-.57 1.51-1.36 2.24-2.27-.3-.4-.59-.79-.88-1.18-.34-.46-.64-.9-.97-1.31-.61-.76-1.51-1.28-2.5-1.34-.03-.01.14-.17.29-.21Z"
        fill="#0081FB"
      />
    </svg>
  );
}

export function YouTubeLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="5" width="20" height="14" rx="4" fill="#FF0000" />
      <polygon points="10,8.5 16,12 10,15.5" fill="#FFFFFF" />
    </svg>
  );
}

export function PosLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="18" height="11" rx="2.5" fill="#202223" />
      <rect x="5.5" y="6.5" width="13" height="6" rx="1.5" fill="#FFFFFF" />
      <path d="M7 18.5h10v2.5H7v-2.5Z" fill="#202223" />
      <path d="M10.5 15h3v3.5h-3V15Z" fill="#202223" />
    </svg>
  );
}

export function BuyButtonLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="5" width="20" height="14" rx="3.5" fill="#3B82F6" />
      <path d="M7.5 10.5L10 12L7.5 13.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 13.5H17" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function AffiliatesLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="6.5" r="3.5" fill="#8B5CF6" />
      <circle cx="6" cy="17.5" r="3" fill="#8B5CF6" />
      <circle cx="18" cy="17.5" r="3" fill="#8B5CF6" />
      <path d="M10.2 9.4L7.5 14.5M13.8 9.4L16.5 14.5" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function XLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function TikTokLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
    </svg>
  );
}

export function LinkedInLogo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="#0A66C2" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}
